import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./new-menu-item.module.scss";
import {
  ProductModel,
  getLocalizedProductName,
  getLocalizedProductDescription,
  getLocalizedProductSubName,
} from "../../../shared/data";
import { classNames } from "../../../shared/utils/utils";

interface NewMenuItemProps {
  product: ProductModel;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
}

export const NewMenuItem: FC<NewMenuItemProps> = ({
  product,
  onClick,
  className,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const { i18n, t } = useTranslation();

  const handleClick = (e: React.MouseEvent) => {
    setIsAnimating(true);
    onClick(e);

    setTimeout(() => {
      setIsAnimating(false);
    }, 300);
  };

  const localizedName = getLocalizedProductName(product, i18n.language);
  const localizedSubName = getLocalizedProductSubName(product, i18n.language);
  const localizedDescription = getLocalizedProductDescription(
    product,
    i18n.language,
  );

  return (
    <div className={`${classNames(styles, styles.menuItem)} ${className}`}>
      <div className={styles.topSection}>
        <div className={styles.leftSection}>
          <div className={styles.title}>
            {localizedName}
            {localizedSubName && (
              <span className={styles.subName}> ({localizedSubName})</span>
            )}
          </div>
        </div>
      </div>

      {!!localizedDescription && (
        <div className={styles.description}>{localizedDescription}</div>
      )}
      <div className={styles.bottomSection}>
        <div className={styles.price}>
          {product.isSet && `${product.count} ${t("menu.count")} / `}PLN{" "}
          {product.price}
        </div>

        <button
          className={`${styles.button} ${
            isAnimating ? styles.buttonClicking : ""
          }`}
          onClick={handleClick}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0013 4.16699V15.8337M4.16797 10.0003H15.8346"
              stroke="#F2E9DE"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
